export class AddressModel {
  lat: Number;
  lng: Number;


  public mapToModel(data): AddressModel {
    const addressModel = new AddressModel();
    addressModel.lat = data.lat;
    addressModel.lng = data.lng;

    return addressModel;
  }
}
